import { IOptions } from "components/DropdownSelect";

export const OPCOES_FORNECEDOR: IOptions[] = [
  { value: "continental", label: "Continental" },
  { value: "CBM", label: "CBM" },
];

export const OPCOES_PRENSA: IOptions[] = [
  { value: 1, label: "Máquina 1" },
  { value: 2, label: "Máquina 2" },
  { value: 3, label: "Máquina 3" },
];
